module.exports = __webpack_public_path__ + "static/media/9.c1913867.jpeg";